import { Box, Typography } from '@mui/material'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined'
import { FeeCheck } from '../../api/types'
import { allFeeChecksPassed } from '../../calc/feeChecks'
import { tokens } from '../../theme'

/** Testy (invarianty) + AI kontrola fee běhu (stejný vzor jako kontrola přepočtu jednotek). */
export function FeeChecksPanel({ check, aiTitle }: { check: FeeCheck; aiTitle: string }) {
  const allPassed = allFeeChecksPassed(check.autoTests)
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
            Automatické testy
          </Typography>
          <Box
            component="span"
            sx={{
              borderRadius: '9999px',
              px: '10px',
              py: '2px',
              fontSize: '0.75rem',
              fontWeight: 700,
              bgcolor: allPassed ? tokens.success[100] : tokens.error[100],
              color: allPassed ? tokens.success[700] : tokens.error[700],
            }}
          >
            {allPassed ? 'VŠE OK' : 'NALEZENY CHYBY'}
          </Box>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {check.autoTests.map((test) => (
            <Box key={test.name} sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
              {test.passed ? (
                <CheckCircleOutlineIcon fontSize="small" sx={{ color: tokens.success[500], mt: '2px' }} />
              ) : (
                <CancelOutlinedIcon fontSize="small" sx={{ color: tokens.error[500], mt: '2px' }} />
              )}
              <Box>
                <Typography variant="body2">{test.name}</Typography>
                {test.detail && (
                  <Typography variant="caption" color="text.secondary" component="div">
                    {test.detail}
                  </Typography>
                )}
              </Box>
            </Box>
          ))}
        </Box>
      </Box>

      <Box>
        <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
          {aiTitle}
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {check.aiResults.map((r) => (
            <Box key={r.id}>
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                {r.name} —{' '}
                <Box
                  component="span"
                  sx={{ color: r.status === 'OK' ? tokens.success[700] : tokens.error[700] }}
                >
                  {r.status === 'OK' ? 'V POŘÁDKU' : 'CHYBA'}
                </Box>
              </Typography>
              <Typography variant="caption" color="text.secondary" component="div">
                {r.comment}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  )
}
